import * as React from 'react';
import * as Configuration from '../../../configuration';
import ScanChart from '../ScanChart';
import TypeSummary from './TypeSummary';


type CustomGraphsProps = {
    currentUser: any,
    defaultGraph: string,
    defaultTimespan: any,
    denormalisedData: any,
    denormalisedQuestionData: any,
    groupView: any,
    referenceData: any
};

type CustomGraphsActions = {

};

type CustomGraphsPropsAndActions = CustomGraphsProps & CustomGraphsActions;

class CustomGraphs extends React.PureComponent<CustomGraphsPropsAndActions, any> {
    constructor(props, context) {
        super(props, context);
    }

    getColorArray(data, field) {
        var colors: string[] = data.map((d,i) => d[field]);
        let unique = [...new Set(colors)];
        return unique;
    }
    render() {
        const { groupView, currentUser, denormalisedData, denormalisedQuestionData, referenceData} = this.props;

        let flattenedData = denormalisedData;
        let flattenedQuestionData = denormalisedQuestionData;
        var defaultColors = Configuration.custom.defaultGraphColors;

        /* Unique list of types for type graphs */
        let class1 = flattenedData ? [...new Set(flattenedData.map((d, i) => d.species))] : undefined;
        let class2 = referenceData && referenceData.types ? referenceData.types.map((d, i) => d.label) : undefined;

        let typeColours = flattenedQuestionData ? this.getColorArray(flattenedData, "typeColor") : [];
        var dateGroupBy = this.props.defaultTimespan > 60 || this.props.defaultTimespan === 0 ? 'eventDateByMonth' : 'eventDateByDay';

        var questionGraphs = class2 && flattenedQuestionData ? class2.map((m, i) => {
            var typeData = flattenedQuestionData.filter(q => q.type == m);

            return typeData.length > 0 ?
                <TypeSummary
                    className={undefined}
                    colors={defaultColors}
                    data={flattenedData.filter(q => q.type == m)}
                    defaultClosed={this.props.defaultGraph.toLowerCase() != m.toLowerCase()}
                    displayIcon={true}
                    displayUsers={groupView}
                    key={i}
                    questionData={typeData}
                    title={`${m}`}
                /> : undefined;

        }) : undefined;


        return (
            <div className="mt-2">

                <ScanChart
                    defaultClosed={this.props.defaultGraph.toLowerCase() != "total"}
                    discrete={undefined}
                    displayIcon={undefined}
                    height={undefined}
                    title={Configuration.custom.totalsGraphTitle}
                    data={flattenedData}
                    groupBy={['type', dateGroupBy]}
                    collate={true}
                    chartType='LineChart'
                    legend="bottom"
                    colors={typeColours}
                    width={undefined}
                />
                {currentUser ? questionGraphs : undefined}

            </div>
        );
    }
}

export default CustomGraphs;
